import { selectorsTypes } from '../../settings/types'

export const setSupervisors = data => ({
    type: selectorsTypes.registerSupervisors,
    payload: data
})

export const addSupervisor = data => ({
    type: selectorsTypes.addSupervisors,
    payload: data
})

export const removeSupervisor = data => ({
    type: selectorsTypes.removeSupervisors,
    payload: data
})

export const clearSupervisorsState = data => ({
    type: selectorsTypes.clearSupervisors,
    payload: data
})